module finadai.app.granters.list {
  export var NAME = "finadai.app.granters.list";
  function grantersListController($scope, $q: ng.IQService, grantersService: services.GrantersService, notify, $http: ng.IHttpService, $state: ng.ui.IStateService) {

    $scope.selected = [];
    $scope.limitOptions = [5, 10, 15];

    $scope.options = {
      rowSelection: true,
      multiSelect: true,
      autoSelect: true,
      decapitate: false,
      largeEditDialog: false,
      boundaryLinks: false,
      limitSelect: true,
      pageSelect: true
    };

    $scope.query = {
      order: '-updated_at._date',
      limit: 10,
      page: 1
    };

    $scope.toggleLimitOptions = function () {
      $scope.limitOptions = $scope.limitOptions ? undefined : [5, 10, 15];
    };

    $scope.reload = () => {
      $scope.promise = grantersService.get().then(response => {
        $scope.granters = response.data;
        return response;
      });
    }
    $scope.reload();
    $scope.remove = id => {
      $q.all($scope.selected.map(item => grantersService.remove(item.id))).then(responses => {
        $scope.selected = [];
        notify('Registro(s) eliminado(s)')
        $scope.reload();
      })
    }
    $scope.edit = e => {
      $state.go('app.granters.detail', {agentId: $scope.selected[0].id});
    }
  }
  export function run() {
    var list = angular.module(NAME, []);
    list.controller('grantersListController', grantersListController);
  }
}
finadai.app.granters.list.run();